import { StatusMessageResponse } from '@shared/models';

export interface PatientById {
  id: number;
  fullname: string;
  birthday: string | null;
  phone_number: string;
  id_number: number;
  address: string;
  email: string;
  gender: string;
  health_plan: string;
  id_card: number;
  prepaid_health_plan: string;
  health_insurance_id: string;
  pathologies: PathologyResponse[];
  doctors: DoctorResp[];
  asociated_medics?: DoctorResp[];
  clientFullname?: string;
  tutor_name?: string;
}

export interface DoctorResp {
  fullname: string;
  medic_id: number;
}

export interface PathologyResponse {
  id: number;
  name: string;
  description?: string;
}

export interface PatientByIdResponse extends StatusMessageResponse {
  data: PatientById;
}
